export default {
  login: {
    new_user: {
      text: 'New to Trainn?',
      link: 'Sign up for free'
    },
    title: 'Good to have you back',
    // description:
    //   'Sign in to accelerate user adoption by creating professional product training videos in minutes.',
    description:
      'Welcome back! Enter your password below to continue, or use one of our quick login options.',
    partner_description: 'Sign in to accelerate training at scale',
    google: 'Sign in with Google',
    login_with_email: 'Login',
    continue_with_email: 'Log in using email',
    forgot_password: 'Forgot password?',
    terms: 'By logging in you agree to our terms and conditions',
    workspace_domain: 'Workspace Domain',
    login_with_sso: 'Login',
    go_to_login_with_sso: 'Login with Single Sign-On',
    go_to_login: 'Go to Login Page'
  },
  register: {
    existing_user: {
      text: 'Have a Trainn account already?',
      link: 'Log In'
    },
    user_exists:
      'You already have an account associated with this email id. Kindly login to continue.',
    title: 'Create your account',
    change: 'Change',
    description: {agree:'I agree to Trainn’s' , terms: 'Terms' , and : 'and', privacy: 'Privacy Policy'},
    google: 'Sign up with Google',
    email_sign_up: {
      email: 'Enter your work email',
      email_placeholder: 'john@yoda.io',
      password: 'Password',
      confirm_password: 'Reenter password',
      otp: 'One time password',
      otp_placeholder: 'Enter 6-digit code',
      otp_desc: 'OTP is valid for 5 minutes',
      send_otp: 'Send OTP',
      continue_with_email: 'Verify Account',
      otp_undelivered: 'Haven’t received the code yet?',
      resend_otp: 'Send again',
      otp_sent: 'OTP has been sent to your mail',
      reset_password: 'Your password has been reset. Kindly login to continue!',
      verify_otp: 'Verify and Proceed',
      set_password: 'Set Password',
      password_title: 'Setup your password',
      create_account: 'Create account',
      user_exists: 'User already exists. Please try logging in.',
      reset_password_desc:
        'One time password will be sent to the given email address',
      reset_password_title: 'Reset password',
      set_password_title: 'Set your account password',
      verify_otp_desc: 'Verify your account',
      verify_otp_cta_reset: 'Verify & Reset password',
      verify_otp_cta_set: 'Verify & Set password',
      verify_otp_cta_signup: 'Verify Account',
      set_password_cta_reset: 'Reset & Login',
      set_password_cta_set: 'Update & Login',
      set_password_cta_signup: 'Continue',
      reset_password_veriy_otp_desc:
        'We have sent an one time password(OTP) to your email address. Please verify it to reset your password.',
      set_password_veriy_otp_desc:
        'We have sent an one time password(OTP) to your email address. Please verify it to set your password.',
      set_password_veriy_otp_signup_desc:
        "We've sent a verification code to your email.",
      passowrd_description:
        // 'Your password should have atleast one upper case character, one lower case character, one special character, one number and should have minimum 8 characters'
        'Your password must have: <br/> 8 characters minimum <br/> 1 uppercase letter <br/> 1 number <br/> 1 special character (!@#$, etc.)'
    },
    terms: 'By signing up you agree to our terms and conditions',
    profile: {
      title: 'Tell us about yourself',
      alternate_title: 'Help us serve you better',
      description: 'This helps us personalize your Trainn experience.',
      alternate_description: 'We’re making a few improvements. Tell us your goal so we can personalize your Trainn experience.',
      name: 'Your Name',
      placeholder: 'Chewbacca',
      cta: 'Set & Continue',
      continue: 'Continue'
    },
    phone: {
      name: 'Your Phone Number',
      placeholder: '+1 (123) 456-7890',
    },
    workspace: {
      title: "What should we call your workspace?",
      join: "Join your teammates' workspace ",
      description: 'For a more personalised experience',
      input: {
        label: 'Workspace name',
        display_label: 'Workspace display name',
        placeholder: 'Enter workspace name',
        error: 'Please enter a product space name',
        min_length_error: 'Workspace name should have a minimum of 4 characters'
      },
      domain: {
        label: 'Domain name',
        placeholder: 'Enter domain name',
        description: `We will generate %{domain}.trainn.co as your workspace URL`,
        join: `Allow anyone with an @%{domain} domain to join this workspace`,
        error: 'Please enter a valid domain name',
        already_exists: 'Given domain name already exists',
        validity:
          'Your domain name should be atleast 4 characters and should not contain any special characters'
      }
    },
    invite_team: {
      title: 'The more the merrier',
      description: `Let’s invite your team to <b>%{domain}</b>. They will be given Creator access by default.`,
      cta: 'Send Invites & Continue',
      input: {
        placeholder: 'Separate emails with space, comma or enter'
      },
      skip: 'You can skip and',
      later: 'do this later'
    },
    extension: {
      title: 'Install Extension',
      description:
        'Almost done! Download our chrome extension and record your first workflow right away!',
      btn: 'Install Extension',
      skip: 'I will install later'
    },
    btn: {
      proceed: 'Finish Setup',
      update: 'Update',
      quick_start_guide: 'Quick start guide',
      create_new_workspace: 'Create New Workspace'
    }
  },
  signupTestimonial: {
    testimonial_2: {
      title:
        'Good value for an <br/> <span> all-around solution </span>',
      review: 'I appreciate having a single tool that integrates content creation, management, and hosting capabilities',
      author: 'Shelby B.',
      role: 'VP of Customer Success',
      tag1: 'SMB',
      tag2: '51-200 Employee'
    },
    testimonial_3: {
      title:
        'Great <span> tool </span> with <br/> great <span> support </span>',
      review: 'We were training partners with live training sessions that took a lot of time. Now we use Trainn’s LMS and provide video content for partners to learn how to use our product.',
      author: 'Guilherme Furst',
      role: 'Partner Manager',
      tag1: 'SMB',
      tag2: '51-200 Employee'
    },
    logos_description: 'You’re in good company. Try Trainn for free.'
  }
};
